import React from "react";
import { Check, Loader2, Route, X } from "lucide-react";
import { Button } from "src/shadcn/ui/button";
import { RelabelCaseRecord, RoutingActions } from "src/types";

interface RoutingActionCellProps {
  case_: RelabelCaseRecord;
  actions: RoutingActions;
}

const RoutingActionCell: React.FC<RoutingActionCellProps> = ({ case_, actions }) => {
  const pending = actions.pendingByCaseId.get(case_.id);
  const isConfirming = pending === "confirm";
  const isCancelling = pending === "cancel";
  const isRouting = pending === "route";
  const anyPending = !!pending;

  if (case_.routedLocationId) {
    return (
      <div className="flex items-center justify-end gap-2">
        <Button
          size="sm"
          variant="outline"
          disabled={anyPending}
          onClick={() => actions.onCancelRouting(case_)}
          title="Cancel routing"
          className="text-xs h-8 px-3 gap-1.5 border-secondary-300 text-secondary-700 hover:bg-secondary-100"
        >
          {isCancelling ? <Loader2 className="h-3 w-3 animate-spin" /> : <X className="h-3 w-3" />}
          {isCancelling ? "Cancelling..." : "Cancel"}
        </Button>
        <Button
          size="sm"
          disabled={anyPending}
          onClick={() => actions.onConfirmPlacement(case_)}
          className="bg-emerald-600 hover:bg-emerald-700 text-white text-xs h-8 px-3 gap-1.5"
        >
          {isConfirming ? <Loader2 className="h-3 w-3 animate-spin" /> : <Check className="h-3 w-3" />}
          {isConfirming ? "Placing..." : "Confirm Placed"}
        </Button>
      </div>
    );
  }
  return (
    <div className="flex items-center justify-end gap-2">
      <Button
        size="sm"
        disabled={anyPending}
        onClick={() => actions.onRouteNow(case_)}
        className="bg-amber-600 hover:bg-amber-700 text-white text-xs h-8 px-3 gap-1.5"
      >
        {isRouting ? <Loader2 className="h-3 w-3 animate-spin" /> : <Route className="h-3 w-3" />}
        {isRouting ? "Routing..." : "Route Now"}
      </Button>
    </div>
  );
};

export { RoutingActionCell };
